import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { CaseService } from '../../../shared/services/case.service';
import { CognitoUtil } from '../../../shared/services/cognito.service';
import { FormControl, FormGroup } from '@angular/forms';
import { EguardConfirmatialogComponent } from '../../../../core/components/confirm-dialog/confirm-dialog.component';
import { UserService } from '../../../shared/services/user.service';
import { LocalUserService } from '../../../shared/services/localUser';
import { PreSignService } from '../../../shared/services/preSign.service';
import { environment } from '../../../../../environments/environment';
import { falseIfMissing } from 'protractor/built/util';
import { ConfirmationDialogComponent } from '../../../shared/dialog/confirmation-dialog/confirmation-dialog.component';
import { Role } from '../../../shared/models/role';
import * as moment from 'moment';
import { NotifyPopupComponent } from '../notify-popup/notify-popup.component';

@Component({
  selector: 'eguard-case-action',
  templateUrl: './case-action.component.html',
  styleUrls: ['./case-action.component.css'],
  providers: [
    LocalUserService,
    PreSignService
  ]
})
export class CaseActionComponent implements OnInit {

  myControl: FormControl = new FormControl();

  options = [
    'One',
    'Two',
    'Three'
  ];
  // come from user
  public case: string;
  public org: string;
  public type: string

  // component variables
  caseData: any = null;
  token: string;
  caseDocuments: any;
  userID: string;
  userRole: string;
  uploadLoading: boolean;

  commentForm: FormGroup;

  caseContacts = [];

  // confirm boxes
  dialogRef: any;

  loading = false;

  mondays = []

  // below are for the datepicker

  // this just holds todays date.
  // this is used so they can not pick anydate before today and so it starts today.
  dateToday = new Date();

  // this is a array of blocked dates
  hearingBlockedDates = [0, 5, 6];
  loadingDeny = false;
  mailBlockedDates = [0, 6];

  error: any[];

  qualifiedAs : string;

  // this holds the value of the date pickers.
  hearingForm = {
    hearingDate: null,
    hearingHour: null,
    hearingMinute: null,
    hearingPartOfDay: null,
    mailDate: null,
    message: []
  };

  hearingData = {
    hearingDate: null,
    hearingHour: null,
    hearingMinute: null,
    hearingPartOfDay: null,
    mailDate: null,
    message: []
  }

  caseForm = {
    caseNumber: null,
    guardianAdLitemId: null,
    coGuardianAdLitemId: null,
    message: [],
    email: null
  };

  // times
  hours = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  minutes = ['00', '15', '30', '45'];

  acceptanceData: any;

  // guardian
  guardianForm: FormGroup;
  guardianFormMessage: string = null;
  allowSecondGuardian = false;

  guardianList: any;
  guardianItem: any;

  guardianDetail = {
    first_name:null,
    last_name:null,
    email:null,
    phone_number:null,

  };

  constructor(
    public thisDialog: MatDialogRef<CaseActionComponent>,
    public dialog: MatDialog,
    private caseService: CaseService,
    private cognito: CognitoUtil,
    private userService: UserService,
    private localUser: LocalUserService,
    private preSign: PreSignService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

  }

  setMonday() {
    let mondays = []
    let date = new Date();

    // Total no of mondays
    // let totalCount = 4
    // let monthNo = moment().month();

    // for(let i = monthNo ; i< monthNo + totalCount; i++){
    //   let monday = moment().set('date',1).set('month',i).day(15);
      // mondays.push({
      //   "date":monday.format("dddd, MMMM Do YYYY"),
      //   "value":monday
      // });
    // }

    // this.mondays = mondays;

    // for (var i = date.getMonth(); i < date.getMonth() + 4 ; i++) {
    //   let date = new Date();
    //   date.setMonth(i);
    //   date.setDate(1);
    //   let monday = moment(date)
    //     .startOf('month')
    //     .day("Monday");

    //   if (monday.date() > 7) monday.add(7, 'd');
    //   var month = monday.month();
    //   var new_date = moment(monday, "DD-MM-YYYY").add(14, 'days');
    //   this.mondays.push({
    //     // new_date.format("dddd, MMMM Do YYYY")
    //     "date":new_date.format("dddd, MMMM Do YYYY"),
    //     "value" : new_date
    //   });
    // }
    this.loading = true;
    this.caseService.getCaseHearingDates(this.org)
    .subscribe(result => {
      this.loading = false;
      if(result) {
        this.mondays = [];
        this.mondays = result;
      }
    });
  }
  ngOnInit() {
    this.commentForm = new FormGroup({
      comment: new FormControl('')
    });

    this.guardianForm = new FormGroup({
      guardianOne: new FormControl(''),
      guardianOneFirstName: new FormControl(''),
      guardianOneLastName: new FormControl(''),
      guardianTwo: new FormControl(''),
      guardianTwoFirstName: new FormControl(''),
      guardianTwoLastName: new FormControl(''),
      guardianCoBool: new FormControl(false),
      bond: new FormControl(false),
      bondAmount: new FormControl(''),
      firstGuardianMode: new FormControl(''),
      secondGuardianMode: new FormControl('')
    });

    this.case = this.data.case;
    this.org = this.data.org;
    this.type = this.data.type;

    this.userID = this.localUser.getUserId();
    this.userRole = this.localUser.getRole();

    if(['JUDGEMENT'].includes(this.type)){
      //No need to call API's which is not required while setting judgement
    }else{
      this.setMonday();
    }
    this.getCaseData();
  }

  getCaseData() {

    this.caseService.getCaseById(this.org, this.case)
      .subscribe(result => {
        this.caseData = result;
        this.caseForm.caseNumber = result.summary.case_number;
        this.fillContacts();
        this.acceptance();
        this.getGuardianList();

        if ((this.userRole == 'CLERK' || this.userRole == 'JUDGE') && this.caseData.summary.current_form == 'TWOTHREE' && this.caseData.summary.status == 'FILED_FOR_JUDGE') {
          //this.getGuardianItem()
        }

        if(this.data.guardianAdlitem){
          this.loading=true;
          this.assignCaseNumber();

        }
      });
  }

  getGuardianList() {
    this.userService.getUsersByRole(this.org, Role.GUARDIAN)
      .subscribe(list => {
        this.guardianList = list;
      })
  }

  fillContacts() {

    this.caseContacts = [];

    for (let i = 0; i < this.caseData.contacts.length; i++) {

      if( this.caseData.contacts[i]){

        let contact = {
          id: i,
          name: this.caseData.contacts[i].name,
          position: '',
          email: this.caseData.contacts[i].email
        };

        if (this.caseData.contacts[i].relationship == null) {
          contact.position = this.caseData.contacts[i].role;
        } else {
          contact.position = this.caseData.contacts[i].relationship;
        }

        this.caseContacts.push(contact);
      }
    }
  }

  acceptance() {

    if (this.caseData.acceptance === undefined || this.caseData.acceptance == null) {
      return;
    }

    if (this.caseData.acceptance.fiduciary_id === 'fiduciaryId') {
      return;
    }

    let fiduciaryEmail = null;
    let coFiduciaryEmail = null;
    let fiduciaryResult = this.caseData.acceptance.acceptance;
    let coFiduciaryResult = this.caseData.acceptance.cofiduciary_acceptance;

    for (let i = 0; i < this.caseData.contacts.length; i++) {
      if (fiduciaryEmail !== null) {
        if (this.caseData.acceptance.cofiduciary_id === null) {
          break;
        }
      }

      if (this.caseData.contacts[i].user_id === this.caseData.acceptance.fiduciary_id) {
        fiduciaryEmail = this.caseData.contacts[i].email;
      }

      if (this.caseData.contacts[i].user_id === this.caseData.acceptance.cofiduciary_id) {
        coFiduciaryEmail = this.caseData.contacts[i].email;
      }

    }

    this.acceptanceData = {
      fiduciaryEmail: fiduciaryEmail,
      coFiduciaryEmail: coFiduciaryEmail,
      fiduciaryResult: fiduciaryResult,
      coFiduciaryResult: coFiduciaryResult
    };

  }

  guardianSubmit() {

    this.loading = true;
    this.error = [];

    let guardianOneUser = {
      email: this.guardianForm.controls.guardianOne.value,
      role: 'GUARDIAN',
      first_name: this.guardianForm.controls.guardianOneFirstName.value,
      last_name: this.guardianForm.controls.guardianOneLastName.value
    };

    let guardianTwoUser = {
      email: this.guardianForm.controls.guardianTwo.value,
      role: 'GUARDIAN'
    };

    if (!this.validateEmail(guardianOneUser.email)) {
      this.error.push('Fiduciary email invalid');
    }

    if (this.guardianForm.controls.guardianCoBool.value) {
      if (!this.validateEmail(guardianTwoUser.email)) {
        this.error.push('Co-Fiduciary email invalid.')
      }
    }

    if (this.guardianForm.controls.bondAmount.value === '') {
      this.error.push('Bond Amount must be filled in.')
    }

    if (this.error.length !== 0) {
      this.loading = false;
      return;
    }

    this.userService.postUserInOrg(guardianOneUser, this.org)
      .subscribe(firstGuard => {

        let acceptData = {
          'acceptance': null,
          'cofiduciary_acceptance': null,
          'undersigned': 'ADMINISTRATOR',
          'other_text': null,
          'fiduciary_id': firstGuard.id,
          'cofiduciary_id': null
        };

        if (this.guardianForm.controls.guardianCoBool.value) {

          this.userService.postUserInOrg(guardianTwoUser, this.org)
            .subscribe(secondGuard => {

              acceptData = {
                'acceptance': null,
                'cofiduciary_acceptance': null,
                'undersigned': 'ADMINISTRATOR',
                'other_text': null,
                'fiduciary_id': firstGuard.id,
                'cofiduciary_id': secondGuard.id
              };

              this.postGuardians(acceptData);

            });

        }
        else {
          this.postGuardians(acceptData);
        }

      });
  }

  postGuardians(acceptData) {

    // put background api here
    let backgroundRequest = {
      first_name: this.guardianForm.controls.guardianOneFirstName.value,
      last_name: this.guardianForm.controls.guardianOneLastName.value,
      email: this.guardianForm.controls.guardianOne.value
    };

    // this.userService.postUserBackgroundRequest(this.org, acceptData.fiduciary_id, backgroundRequest)
    //   .subscribe(result => {

    //     this.userService.postUserBackgroundProcess(this.org, acceptData.fiduciary_id)
    //       .subscribe(resultt => {

    this.caseService.postGuardians(this.case, acceptData).subscribe(result => {
      this.confirmGuardianSubmit();
    });

    //       });

    //   });
  }

  validateEmail(email) {
    let re = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  guardianAction(choice) {

    // choice can be
    // ACCEPT (true) or DECLINE (false)

    /*
        case acceptance
        as of 2/14/2018
        {
          'acceptance': null,
          'cofiduciary_acceptance': null,
          'undersigned': 'ADMINISTRATOR',
          'other_text': null,
          'fiduciary_id': firstGuard.id,
          'cofiduciary_id': null
        }
    */

    this.loading = false;
    this.loadingDeny = false;

    if (choice) {
      this.loading = true;
      this.loadingDeny = false;
    }
    else {
      this.loading = false;
      this.loadingDeny = true;
    }

    let acceptData = this.caseData.acceptance;

    let data = {
      status: 'NEEDS_UPLOAD_FROM_GUARDIAN',
    };

    let genData = {
      'Check_Box1': false,
      'Check_Box2': false,
      'Check_Box3': false,
      'Check_Box4': false,
      'Check_Box5': false,
      'Check_Box6': false,
      'Check_Box7': false,
      'SixPlaceHolder': '',
      'fiduciary': [],
      'form_id': '3.4',
      'print': false
    };

    if (acceptData.fiduciary_id !== null) {
      genData.fiduciary.push(acceptData.fiduciary_id);
    }

    if (acceptData.cofiduciary_id !== null) {
      genData.fiduciary.push(acceptData.cofiduciary_id);
    }

    if (acceptData.fiduciary_id === this.userID) {
      acceptData.acceptance = choice;
    }

    if (acceptData.cofiduciary_id === this.userID) {
      acceptData.cofiduciary_acceptance = choice;
    }

    if ((acceptData.acceptance != null && acceptData.cofiduciary_acceptance != null) || (acceptData.acceptance != null && acceptData.cofiduciary_id == null)) {

      if (acceptData.acceptance === false || acceptData.cofiduciary_acceptance === false) {

        data = {
          status: 'APPOINT_GUARDIAN'
        };

        this.caseService.postGuardians(this.case, acceptData)
          .subscribe(ruslt => {

            this.caseService.putCaseNew(this.org, this.case, data)
              .subscribe(result => {
                this.guardianNotify('One or more guardians declined. Results will be sent to court.');
              });

          });

      }
      else {

        if (acceptData.acceptance !== null) {
          acceptData.acceptance ? genData.Check_Box6 = true : genData.Check_Box4 = true;
        }

        if (acceptData.cofiduciary_acceptance !== null) {
          acceptData.cofiduciary_acceptance ? genData.Check_Box7 = true : genData.Check_Box5 = true;
        }

        switch (acceptData.undersigned) {

          case 'ADMINISTRATOR':
            genData.Check_Box2 = true;
            break;

          case 'EXECUTOR':
            genData.Check_Box1 = true;
            break;

          case 'other':
            genData.Check_Box3 = true;
            break;

        }

        this.caseService.postGuardians(this.case, acceptData).subscribe(result => {

          this.caseService.putCaseNew(this.org, this.case, data)
            .subscribe(result => {

              this.caseService.postAcceptance(this.org, this.case, genData)
                .subscribe(result => {
                  this.loading = false;
                  this.guardianNotify('PDF will be generated soon.');
                });

            });

        });

      }

    }

    else {
      this.caseService.postGuardians(this.case, acceptData).subscribe(result => {

        this.guardianNotify('Your decision has been recorded.');

      });
    }

  }

  guardianNotify(msg) {
    this.dialogRef = this.dialog.open(EguardConfirmatialogComponent, {
      data: {
        confirmMessage: msg
      }
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        this.thisDialog.close(true);
      });
  }

  confirmGuardianSubmit() {

    let data = {
      status: this.guardianForm.controls.bond.value === true ? 'APPROVED_BY_JUDGE' : 'APPROVED_BY_CLERK',
      bond: this.guardianForm.controls.bondAmount.value
    };

    this.caseService.putCaseNew(this.org, this.case, data)
      .subscribe(result => {
        this.dialogRef = this.dialog.open(ConfirmationDialogComponent,{
          panelClass:"confirmDetails"

        })
        this.dialogRef.componentInstance.msg = `Guardians have been assigned`;

        this.dialogRef.afterClosed()
          .subscribe(response => {
            if (response === true)
              this.thisDialog.close(true);
          });
      });

  }

  cleanDate(date) {
    let temp = new Date(date);
    let month: any = (temp.getMonth() + 1);
    if (parseInt (month) < 10) {
    	month = '0' + month;
    }
    let day: any = temp.getDate();
    if (parseInt (day) < 10) {
    	day = '0' + day;
    }
    let fullDateStr = month  + '/' + day + '/' + temp.getFullYear();
    return fullDateStr;
  }

  caseApproved(final: boolean) {
    if (final) {
      this.loading = true;

      let data = {
        status: 'APPOINT_GUARDIAN',
        judgeQualifiedAs: this.qualifiedAs
      };

      this.caseService.putCaseNew(this.org, this.case, data)
        .subscribe(result => {
          this.thisDialog.close();
        });

      return 0;
    }

    this.dialogRef = this.dialog.open(ConfirmationDialogComponent,{
      panelClass:"confirmDetails"

    });
    this.dialogRef.componentInstance.msg = 'You are confirming this case will be approved.';

    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (response) {
          this.caseApproved(true);
        }
      });
  }

  caseDenied(final: boolean) {
    if (final) {
      this.loading = true;

      let data = {
        status: 'DENIED_BY_JUDGE'
      };

      this.caseService.putCaseNew(this.org, this.case, data)
        .subscribe(result => {
          this.dialogRef.close();
        });

      return 0;
    }

    this.dialogRef = this.dialog.open(ConfirmationDialogComponent,{
      panelClass:"confirmDetails"

    });
    this.dialogRef.componentInstance.msg = 'You are confirming this case will be denied.';

    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (response) {
          this.caseDenied(true);
        }
      });
  }

  uploadTHREEFIVE(event) {
    this.loading = true;
    // this makes sure they did not just back out of the file selector.
    if (event.target.files.length === 0) {
      return 0;
    }

    let file = event.target.files[0];

    this.preSign.getPresign(this.org, this.case, `3.5.pdf`)
      .subscribe(result => {

        this.preSign.uploadFile(result, file)
          .subscribe(resultt => {
            let data = {
              status: 'APPROVED_BY_JUDGE'
            };

            this.caseService.putCaseNew(this.org, this.case, data)
              .subscribe(resulttt => {
                this.dialogRef = this.dialog.open(EguardConfirmatialogComponent, {
                  data: {
                    confirmMessage: 'Bond has been submitted'
                  }
                });

                this.dialogRef.afterClosed()
                  .subscribe(response => {
                    this.thisDialog.close(true);
                  });
              });
          });

      });
  }

  /*
  hearingForm = {
    hearingDate: '',
    hearingHour: '',
    hearingMinute: '',
    hearingPartOfDay: '',
    mailDate: '',
    message: ''
  };
   */
  hearingSubmit(value) {
    this.loading = true;
    this.hearingForm.message = [];
    this.error = [];

    let hearingData = this.hearingData;

    let hearing = this.cleanDate(hearingData.hearingDate);
    let mail = this.cleanDate(new Date);
    let time = (hearingData.hearingPartOfDay === 'AM' ? hearingData.hearingHour : hearingData.hearingHour + 12) + ':' + hearingData.hearingMinute;

    let data = {
      appointment_date: hearing + ' ' + time,
      mail_date: hearing,
      form_id: '2.4'
    };
    this.caseService.postHearingDate(this.org, this.case, '2.4', data)
      .subscribe(result => {
        let data = {
          status: 'FILED_FOR_JUDGE'
        };

        this.caseService.putCaseNew(this.org, this.case, data)
          .subscribe(result => {
            this.loading = false;
            this.thisDialog.close(true);
          });
      });
  }

  close() {
    this.thisDialog.close(true);
  }

  assignCaseNumber() {

    this.caseForm.message = [];
    this.loading =true;

    let data = {
      status: 'SET_HEARING',
      current_form: 'TWOTHREE',
      form_id: '2.3',
      case_number: this.caseForm.caseNumber,
      petitionData: this.caseData.petitionData
    };

    let pattern = /\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/gm;

    if (this.caseForm.caseNumber === null) {
      this.caseForm.message.push('No case number entered.');
    }
    this.loading =true;
    if (this.caseForm.message.length === 0) {
      this.caseService.getGuardianItem(this.org, this.case, this.caseForm.caseNumber).subscribe(result => {

        this.guardianDetail = result.user;
        this.loading=false;
      })
    }
  }

  threeFiveAccept(final: boolean) {
    if (final) {
      this.loading = true;

      let data = {
        status: 'APPROVED_BY_JUDGE'
      };

      this.caseService.putCaseNew(this.org, this.case, data)
        .subscribe(result => {
          this.thisDialog.close();
        });

      return 0;
    }

    this.dialogRef = this.dialog.open(EguardConfirmatialogComponent, {
      data: {
        confirmMessage: 'Approve the bond?'
      }
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (response) {
          this.threeFiveAccept(true);
        }
      });
  }

  threeFiveDeny(final: boolean) {
    if (final) {
      this.loading = true;

      let data = {
        status: 'DENIED_BY_CLERK'
      };

      this.caseService.putCaseNew(this.org, this.case, data)
        .subscribe(result => {
          this.thisDialog.close();
        });

      return 0;
    }

    this.dialogRef = this.dialog.open(EguardConfirmatialogComponent, {
      data: {
        confirmMessage: 'Deny the bond?'
      }
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (response) {
          this.threeFiveDeny(true);
        }
      });
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/main/content/common/case-action/case-action.component.ts